import { useAppStore } from '@booking-portal/stores/app-store';
import dayjs from 'dayjs';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useCurrentLocation() {
  const route = useRoute();
  const locationStore = useAppStore();
  const location = computed(() => locationStore.location);
  const timeZone = computed(() => locationStore.location?.timeZone || '');
  const locationId = computed(() => location.value?.id);
  const routeLocationId = computed(() => {
    // Force Vue to track route.params.locationId as a dependency
    const routeParamsLocationId = route.params.locationId;
    const url = window.location.pathname;
    if (url.includes('customer-portal')) {
      return null;
    }
    return routeParamsLocationId ? +routeParamsLocationId : undefined;
  });

  const consents = computed(() => location.value?.consents || []);
  const customFields = computed(() => location.value?.customFields || []);
  const consentsForRequestInterest = computed(
    () => location.value?.interestRegistrationConsents || []
  );

  return {
    /**
     * The loaded location.
     */
    location,

    earliestAllowedBookingDate: computed(() => {
      const earliest = dayjs(location.value?.earliestBookableDate);
      const currentDayLocation = dayjs(
        location.value?.currentDayLocationTimeZone
      );
      const dateToUse =
        earliest.unix() > currentDayLocation.unix()
          ? location.value?.earliestBookableDate
          : location.value?.currentDayLocationTimeZone;

      const isValid = dayjs(dateToUse).isValid();
      return isValid ? dateToUse : undefined;
    }),
    /**
     * The location id of the loaded location. Will only be set once the location has been loaded.
     */
    locationId,
    /**
     * The location id from the route (NOT FOR CUSTOMER PORTAL). Can be used to immediately update dependent requests without waiting for the location to be loaded.
     */
    routeLocationId,
    locationParams: computed(() => ({ locationId: locationId.value })),
    consents,
    customFields,
    consentsForRequestInterest,
    timeZone,
  };
}
